import {
    slideUp,
    slideDown,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.fifty-fifty-accordion').forEach(section => {

        const wrap = section.querySelector('.ffa-wrap');
        if (!wrap) {return;}

        const items = Array.from(wrap.querySelectorAll(':scope > .ffa-item'));

        const leftWrap  = document.createElement('div');
        const rightWrap = document.createElement('div');

        leftWrap.className  = 'ffa-col-wrap ffa-col-left';
        rightWrap.className = 'ffa-col-wrap ffa-col-right';

        items.forEach((item, index) => {
            if (index % 2 === 0) {
                leftWrap.appendChild(item);
            } else {
                rightWrap.appendChild(item);
            }
        });

        wrap.innerHTML = '';
        wrap.appendChild(leftWrap);
        wrap.appendChild(rightWrap);

        const closeAll = (container) => {
            container.querySelectorAll('.ffa-item.is-active').forEach(item => {
                item.classList.remove('is-active');
                slideUp(item.querySelector('.ffa-desc'));
            });
        };

        const initAccordion = (container, openFirst = false, otherContainer = null) => {
            const accItems = container.querySelectorAll('.ffa-item');

            accItems.forEach((item, index) => {
                const title   = item.querySelector('.ffa-title-wrap');
                const content = item.querySelector('.ffa-desc');

                if (!title || !content) {return;}

                if (openFirst && index === 0) {
                    item.classList.add('is-active');
                    content.style.display = 'block';
                } else {
                    item.classList.remove('is-active');
                    content.style.display = 'none';
                }

                title.addEventListener('click', () => {
                    const isOpen = item.classList.contains('is-active');

                    accItems.forEach(i => {
                        if (i !== item && i.classList.contains('is-active')) {
                            i.classList.remove('is-active');
                            slideUp(i.querySelector('.ffa-desc'));
                        }
                    });

                    if (!isOpen && otherContainer) {
                        closeAll(otherContainer);
                    }

                    if (isOpen) {
                        item.classList.remove('is-active');
                        slideUp(content);
                    } else {
                        item.classList.add('is-active');
                        slideDown(content);
                    }
                });
            });
        };

        initAccordion(leftWrap, true, rightWrap);
        initAccordion(rightWrap, false, leftWrap);

    });

});
